/**
 * Default PostHog API host used whenever a community/env config doesn't specify one.
 * Mirrors DEFAULT_POSTHOG_HOST in networked-shared-interfaces/constants/posthog-constants.ts -
 * duplicated here rather than imported since fe-shared-lib is a standalone submodule that
 * shouldn't depend on sibling submodule paths that can differ across consuming apps.
 */
export const DEFAULT_POSTHOG_HOST = 'https://us.i.posthog.com';

/**
 * Event catalog (Oct 2026). Mirrors ANALYTICS_SCHEMA_VERSION in
 * networked-shared-interfaces/constants/analytics-events.ts (duplicated for the same reason as
 * DEFAULT_POSTHOG_HOST above; fe-main's registry test asserts the two stay equal).
 */
export const ANALYTICS_SCHEMA_VERSION = 1;
export const WEB_PLATFORM = 'web';

/**
 * The QA project's browser key (a public token). Test-data guard (2026-10-28): a build that is not
 * production sends Networked's own events here whatever key it was built with, so a developer running
 * the production configuration can never reach the production project. Mirrors be-main's
 * SecretUtility.getPosthogQaIngestionKey.
 */
export const POSTHOG_QA_PROJECT_KEY = 'phc_ntRywRPrYAouGHQ2N3gpKQCMHup5STD3a5wcYZVy4e54';
